// Purpose: Enumerated type for database operations.
export enum operations {
  ADD = 'add',
  REMOVE = 'delete'
}

export enum transactions {
  READ_ONLY = 'readonly',
  READ_WRITE = 'readwrite'
}
